import { useState, useEffect } from 'react'
import { getCookie, setCookie } from '../../utils/cookies'

import Image from '../Image/Image'
import RichText from '../RichText/RichText'

export default function PopupCard (props = {
    className: null,
    modified: null,
    img: null,
    heading: null,
    richText: null
}) {
    const {
        className,
        modified,
        img,
        heading,
        richText
    } = props

    const id = modified
        && `popup-card-${modified}`

    const [active, setActive] = useState(true)

    useEffect(() => {
        if (getCookie(id))
            setActive(false)
    }, [props])

    if (!active)
        return null

    return (
        <div
            id={id}
            className={`popup-card card pad-0 ${className || ''}`
                .trim()}
        >
            <div className="display-flex justify-content-end">
                <button
                    className="btn-unstyled popup-card-close-btn"
                    aria-label="Close popup"
                    onClick={() => {
                        if (id)
                            setCookie(id, true)

                        setActive(false)
                    }}
                    style={(img || {}).src
                        && ({
                            position: 'absolute',
                            top: 0,
                            right: 0
                        })}
                >
                    <svg
                        className="icon-close"
                        style={{
                            minWidth: 24,
                            minHeight: 24
                        }}
                    >
                        <use xlinkHref="#icon-close" />
                    </svg>
                </button>
            </div>

            <div
                className="display-flex"
                style={{
                    aspectRatio: '1.76'
                }}
            >
                <Image
                    data-object-fit="cover"
                    {...img}
                />
            </div>
            <div className="popup-card-content">
                {heading
                    && (
                        <h2
                            className="body-3 font-weight-medium"
                            style={{
                                lineHeight: 1.4
                            }}
                        >
                            <span>{heading}</span>
                        </h2>)}
                <RichText className="body-4" html={richText} />
            </div>
        </div>
    )
}
